import script from "./zmr-float-layer.vue?vue&type=script&setup=true&lang=js"
export * from "./zmr-float-layer.vue?vue&type=script&setup=true&lang=js"

import "./zmr-float-layer.vue?vue&type=style&index=0&id=4ed51e25&lang=css"

const __exports__ = script;

export default __exports__